import * as React from "react";
import {useEffect, useState} from "react";
import {connect} from "react-redux";
import {IReduxState} from "reducers";
import {RouteComponentProps, Route, Switch} from "react-router-dom";
import {AppRoutes} from "./routes";
import AppBar from "components/header/index";
import Login from "login";
import Footer from "components/footer";
import UpdateEmail from "login/updateEmail";
import GeoLocation from "geolocation";
import Tips from "components/tips";
import {initializeGA} from "analytics/googleAnalyics";
import {saveConfig, saveSearch} from "userform/actions";
import {Flags} from "reducers/flagActions";
import {appConfig} from "app/config";
import "./styles.scss";
import {loadBranchScript, setBranchIdentity} from "analytics/branch";
import {isNativeAndroid, isWebview} from "utils";
import PaymentSuccess from "components/display-msg/paymentSuccess";
import {setPartnerAndroid, setAndroid} from "login/actions";
import {AndroidApiCollection, getAndroidLocalStorageValues} from "utils/android";
import TwoFactorAuth from "login/TwoFactorLogin/TwoFactorAuth";
import useUnload from "utils/UseUnload";
import {getLamProfile} from "profile/api";
import {IProfile} from "profile/interface";
import {Loading} from "web-com";
import RenderOtp from "OTP";
import NetworkStatus from "myshubhlife-component/NetworkStatus";
import LoginV3 from "login/LoginV3";
import {setPaanduProfile} from "profile/actions";
import {logWebEngageEvent} from "analytics/eventApi";
import {webEngageKey} from "config";
interface IConnectProps {
  auth: any;
  routes: any;
  dispatch?: (action: any) => void;
  params?: {
    id: string;
  };
  search: string;
  flags: Flags[];
  pathname: string;
  isAndroid: boolean;
  androidVersion: number;
  query: any;
  utm_source: string;
  authExt: {[key: string]: string};
  isPartnerAndroid: boolean;
}

initializeGA();

interface IProps {
  router: any;
  type: string;
  pathname: string;
  version: number;
}

type FinalProps = IProps & IConnectProps;

export let AndroidApis = new AndroidApiCollection(0);

function App(props: FinalProps & RouteComponentProps) {
  const [checkBeforeMount, updateCheckBeforeMount] = useState<boolean>(true);
  const [requiredMobileOtpVerification, updateRequiredMobileOtpVerification] = useState(true);
  const [loading, setLoading] = useState(false);
  const [profile, setProfile] = useState<IProfile>(null);
  const {phone} = props?.authExt || {};

  useEffect(() => {
    (window as any).webengage.init(webEngageKey);
    (window as any).webengage.onReady(function () {
      var subscribed = (window as any).webengage.webpush.isSubscribed();

      if (subscribed) {
          console.log('User is already subscribed');
      } else {
        (window as any).webengage.webpush.prompt();
      }
    });
  }, [])

  useEffect(() => {
    if (props.auth) {
      fetchLamProfile();
      setBranchIdentity(props.auth.userId);
      if (!props.isAndroid) {
        if (props.auth.existing) {
          logWebEngageEvent({
            event_name: "SignIn",
            event_data: {
              "utm source": props?.utm_source,
              "utm medium": props?.authExt?.utm_medium,
              "utm campaign": props?.authExt?.utm_campaign,
              "device": "Web",
            },
            type: "event",
            user_id: props.auth.userId,
            user: props.user,
          });
        } else {
          logWebEngageEvent({
            event_name: "SignUp",
            event_data: {
              "utm source": props?.utm_source,
              "utm medium": props?.authExt?.utm_medium,
              "utm campaign": props?.authExt?.utm_campaign,
              "device": "Web",
            },
            type: "event",
            user: props.user,
            user_id: props.auth.userId,
          });
        }
        logWebEngageEvent({
          user_id: props.auth.userId,
          type: "event",
          event_name: "WebappOpened",
          event_data: {
            "utm source": props?.utm_source,
            "utm medium": props?.authExt?.utm_medium,
            "utm campaign": props?.authExt?.utm_campaign,
          },
          user: props.user,
        });
      }
    }
  }, [props.auth]);

  const fetchLamProfile = async () => {
    setLoading(true);
    try {
      const profileResponse = await getLamProfile();
      setProfile(profileResponse);
      props.dispatch(setPaanduProfile(profileResponse));
      if (profileResponse?.mobileOtpVerified || props.authExt?.bsInvoker === "admin") {
        updateRequiredMobileOtpVerification(false);
      }
    } catch (e) {}
    setLoading(false);
  };
  const handleOtpClose = () => {
    updateRequiredMobileOtpVerification(false);
    fetchLamProfile();
  };
  function getComponent() {
    if (props.auth) {
      return !loading ?
              (requiredMobileOtpVerification || (phone && profile?.mobile !== phone)) ?
                  <RenderOtp
                      utm_source={props.utm_source}
                      userId={props.auth?.userId}
                      mobileNumber={phone || profile?.mobile}
                      onClose={handleOtpClose}
                  /> : AppRoutes(props.version) :
              <Loading active={loading} msg={"Please wait, we're fetching your details"}/>;
    } else {
      return (
          <Switch>
            <Route exact path={`/:id?/tips`} component={Tips}/>
            <Route exact path={`/:id?/:id2?/updateEmail`} component={UpdateEmail}/>
            <Route exact path={`/:id?/insurancePaymentSuccess`} component={PaymentSuccess}/>
            <Route exact path={`/:id?/payment`} component={PaymentSuccess}/>
            <Route exact path={`/:id?/login-v2`} component={TwoFactorAuth}/>
            <Route exact path={`/:id?/login-v3`} component={LoginV3}/>
            <Route path={`/:id?/`} component={Login}/>
          </Switch>
      );
    }
  }
  if (checkBeforeMount) {
    if ((props.match.params.id === "android" || isNativeAndroid()) || isWebview()) {
      props.dispatch(setAndroid());
    }
    if ((props.match.params.id !== "android" && !isNativeAndroid()) && isWebview()) {
      props.dispatch(setPartnerAndroid());
    }
    loadBranchScript();
    if (props.match.params && props.match.params.id && appConfig.hasOwnProperty(props.match.params.id)) {
      props.dispatch(saveConfig(props.match.params.id, appConfig[props.match.params.id]));
    } else {
      props.dispatch(saveConfig("sl", appConfig.sl));
    }
    if (props.search) {
      props.dispatch(saveSearch(props.search));
    }
    updateCheckBeforeMount(false);
  }
  useEffect(() => {
    if (props.isAndroid) {
      let apiVersion = props.androidVersion;
      if (!apiVersion) {
        const val = getAndroidLocalStorageValues();
        apiVersion = val ? val.apiVersion : null;
      }
      if (apiVersion) {
        AndroidApis = new AndroidApiCollection(props.androidVersion);
      }
    }
  }, [props.androidVersion]);
  return(
    <div className="app">
        {(props.isPartnerAndroid || !props.isAndroid) && <div className="app-bar"><AppBar /></div>}
        <div className={(props.isAndroid && !props.isPartnerAndroid) ? "app-children" : "app-children app-children-padding"}>
          <NetworkStatus />
          {getComponent()}
        </div>
        {(props.isPartnerAndroid || !props.isAndroid) && <div>{props.auth && <Footer partner={props.utm_source}/>}
        </div>}
        {(props.isPartnerAndroid || !props.isAndroid) && props.auth && props.auth.userId && <GeoLocation/>}
      </div>
  );
}

const mapStateToProps = (state: IReduxState): IConnectProps => {
  const auth = state.login.auth ? state.login.auth : null;
  const query = state.router.location.query ? state.router.location.query : null;
  return {
    auth,
    pathname: state.router.location.pathname,
    routes: state.router.routes,
    search: state.router.location.search,
    flags: state.userform.flags,
    isAndroid: state.login.isAndroid,
    androidVersion: state.login.apiVersion,
    query,
    utm_source: state.login.authExt && state.login.authExt.utm_source ? state.login.authExt.utm_source : null,
    authExt: state.login.authExt ? state.login.authExt : {},
    isPartnerAndroid: state.login.isPartnerAndroid,
  };
};

export default connect<IConnectProps, IProps, {}>(mapStateToProps)(App);
